/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  queryOptions as queryOptionsBuilder,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  EmptyTreeInfo,
  GetActivityTypeTreeParams,
  GetActivityTypesParams,
  SimpleActivityType
} from '../../model';

import { customInstance } from '../../../mutator.ts';
import type { ErrorType } from '../../../mutator.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetActivityTypesUrl = (params?: GetActivityTypesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["ids"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }


  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/ActivityType/GetActivityTypes?${stringifiedParams}` : `/api/ActivityType/GetActivityTypes`
}

export const getActivityTypes = async (params?: GetActivityTypesParams, options?: Parameters<typeof customInstance>[1]): Promise<SimpleActivityType[]> => {

  return customInstance<SimpleActivityType[]>(getGetActivityTypesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetActivityTypesQueryKey = (params?: GetActivityTypesParams,) => {
    return [
    `/api/ActivityType/GetActivityTypes`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetActivityTypesQueryOptions = <TData = Awaited<ReturnType<typeof getActivityTypes>>, TError = ErrorType<unknown>>(params?: GetActivityTypesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivityTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetActivityTypesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getActivityTypes>>> = ({ signal }) => getActivityTypes(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getActivityTypes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetActivityTypesQueryResult = NonNullable<Awaited<ReturnType<typeof getActivityTypes>>>
export type GetActivityTypesQueryError = ErrorType<unknown>


export function useGetActivityTypes<TData = Awaited<ReturnType<typeof getActivityTypes>>, TError = ErrorType<unknown>>(
 params: undefined |  GetActivityTypesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivityTypes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActivityTypes>>,
          TError,
          Awaited<ReturnType<typeof getActivityTypes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActivityTypes<TData = Awaited<ReturnType<typeof getActivityTypes>>, TError = ErrorType<unknown>>(
 params?: GetActivityTypesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivityTypes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActivityTypes>>,
          TError,
          Awaited<ReturnType<typeof getActivityTypes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActivityTypes<TData = Awaited<ReturnType<typeof getActivityTypes>>, TError = ErrorType<unknown>>(
 params?: GetActivityTypesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivityTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetActivityTypes<TData = Awaited<ReturnType<typeof getActivityTypes>>, TError = ErrorType<unknown>>(
 params?: GetActivityTypesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivityTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetActivityTypesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetActivityTypesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getActivityTypes>>, TError = ErrorType<unknown>>(params?: GetActivityTypesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActivityTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetActivityTypesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getActivityTypes>>> = ({ signal }) => getActivityTypes(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActivityTypes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetActivityTypesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getActivityTypes>>>
export type GetActivityTypesSuspenseQueryError = ErrorType<unknown>


export function useGetActivityTypesSuspense<TData = Awaited<ReturnType<typeof getActivityTypes>>, TError = ErrorType<unknown>>(
 params: undefined |  GetActivityTypesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActivityTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActivityTypesSuspense<TData = Awaited<ReturnType<typeof getActivityTypes>>, TError = ErrorType<unknown>>(
 params?: GetActivityTypesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActivityTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActivityTypesSuspense<TData = Awaited<ReturnType<typeof getActivityTypes>>, TError = ErrorType<unknown>>(
 params?: GetActivityTypesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActivityTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetActivityTypesSuspense<TData = Awaited<ReturnType<typeof getActivityTypes>>, TError = ErrorType<unknown>>(
 params?: GetActivityTypesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActivityTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetActivityTypesSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetActivityTypeTreeUrl = (params?: GetActivityTypeTreeParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/ActivityType/GetActivityTypeTree?${stringifiedParams}` : `/api/ActivityType/GetActivityTypeTree`
}

export const getActivityTypeTree = async (params?: GetActivityTypeTreeParams, options?: Parameters<typeof customInstance>[1]): Promise<EmptyTreeInfo> => {

  return customInstance<EmptyTreeInfo>(getGetActivityTypeTreeUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetActivityTypeTreeQueryKey = (params?: GetActivityTypeTreeParams,) => {
    return [
    `/api/ActivityType/GetActivityTypeTree`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetActivityTypeTreeQueryOptions = <TData = Awaited<ReturnType<typeof getActivityTypeTree>>, TError = ErrorType<unknown>>(params?: GetActivityTypeTreeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivityTypeTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetActivityTypeTreeQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getActivityTypeTree>>> = ({ signal }) => getActivityTypeTree(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getActivityTypeTree>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetActivityTypeTreeQueryResult = NonNullable<Awaited<ReturnType<typeof getActivityTypeTree>>>
export type GetActivityTypeTreeQueryError = ErrorType<unknown>


export function useGetActivityTypeTree<TData = Awaited<ReturnType<typeof getActivityTypeTree>>, TError = ErrorType<unknown>>(
 params: undefined |  GetActivityTypeTreeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivityTypeTree>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActivityTypeTree>>,
          TError,
          Awaited<ReturnType<typeof getActivityTypeTree>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActivityTypeTree<TData = Awaited<ReturnType<typeof getActivityTypeTree>>, TError = ErrorType<unknown>>(
 params?: GetActivityTypeTreeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivityTypeTree>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActivityTypeTree>>,
          TError,
          Awaited<ReturnType<typeof getActivityTypeTree>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActivityTypeTree<TData = Awaited<ReturnType<typeof getActivityTypeTree>>, TError = ErrorType<unknown>>(
 params?: GetActivityTypeTreeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivityTypeTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetActivityTypeTree<TData = Awaited<ReturnType<typeof getActivityTypeTree>>, TError = ErrorType<unknown>>(
 params?: GetActivityTypeTreeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActivityTypeTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetActivityTypeTreeQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetActivityTypeTreeSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getActivityTypeTree>>, TError = ErrorType<unknown>>(params?: GetActivityTypeTreeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActivityTypeTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetActivityTypeTreeQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getActivityTypeTree>>> = ({ signal }) => getActivityTypeTree(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActivityTypeTree>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetActivityTypeTreeSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getActivityTypeTree>>>
export type GetActivityTypeTreeSuspenseQueryError = ErrorType<unknown>


export function useGetActivityTypeTreeSuspense<TData = Awaited<ReturnType<typeof getActivityTypeTree>>, TError = ErrorType<unknown>>(
 params: undefined |  GetActivityTypeTreeParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActivityTypeTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActivityTypeTreeSuspense<TData = Awaited<ReturnType<typeof getActivityTypeTree>>, TError = ErrorType<unknown>>(
 params?: GetActivityTypeTreeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActivityTypeTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetActivityTypeTreeSuspense<TData = Awaited<ReturnType<typeof getActivityTypeTree>>, TError = ErrorType<unknown>>(
 params?: GetActivityTypeTreeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActivityTypeTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetActivityTypeTreeSuspense<TData = Awaited<ReturnType<typeof getActivityTypeTree>>, TError = ErrorType<unknown>>(
 params?: GetActivityTypeTreeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getActivityTypeTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetActivityTypeTreeSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






